import { Typography } from '@mui/material'
import type { Assistant } from 'types/graphql'

import Row from '../Row/Row'

import AssistantAvatar from './AssistantAvatar'
import AssistantTyping from './AssistantTyping'

const containerSx = {
  gap: 1,
  height: '72px',

  '& .MuiAvatar-root': {
    width: '24px',
    height: '24px',
  },
}

const AssistantThinking = ({
  assistant,
  message,
}: {
  assistant: Assistant
  message?: string
}) => {
  return (
    <Row sx={containerSx}>
      <AssistantAvatar assistant={assistant} />
      {message ? (
        <Typography>
          {message || `${assistant?.firstName || 'Day.ai'} is thinking...`}
        </Typography>
      ) : (
        <AssistantTyping />
      )}
    </Row>
  )
}

export default AssistantThinking
